<template>
    <b-form-group :label="label" :invalid-feedback="errorTxt" :state="state">
        <select2 v-model="inputVal" :state="state" :settings="settings"
                 :disabled="readonly"
        ></select2>
    </b-form-group>
</template>

<script>
    import Select2 from 'v-select2-component';
    import 'select2-bootstrap-theme/dist/select2-bootstrap.css';

    export default {
        props: ['model', 'attribute', 'label', 'options', 'errors', 'readonly', 'placeholder', 'ajaxUrl', 'errorOnly'],
        components: {
            'select2': Select2
        },
        data() {
            return {
                inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
                state: null,
                errorTxt: '',
                settings: {
                    theme: "bootstrap",
                    placeholder: this.placeholder,
                    width: 200,
                    allowClear: true,
                    ajax: {
                        url: process.env.VUE_APP_SERVICE_URL + this.ajaxUrl,
                        headers: {
                            'token': localStorage.getItem('token')
                        },
                        dataType: 'json',
                        data: function (params) {
                            var query = {
                                search: params.term,
                                page: params.page ? params.page : 1
                            }
                            return query;
                        }
                    },

                }
            }
        },
        watch: {
            model: {
                handler(val) {
                    this.state = null;
                    this.errorTxt = '';
                    this.inputVal = val[this.attribute];
                }, deep: true
            },
            inputVal(val) {
                this.state = null;
                this.errorTxt = '';
                this.model[this.attribute] = val;
            },
            errors(val) {
                let hasErr = false;
                if (val.length) {
                    val.forEach(v => {
                        if (v.param === this.attribute) {
                            this.state = false;
                            this.errorTxt = v.msg;
                            hasErr = true;
                        }
                    });
                }
                if (!this.errorOnly) {
                    this.state = !hasErr;
                }
            }
        },
    }
</script>